import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Finance} from '../../../helpers/Urls';

// ─── Action Types ─────────────────────────────────────────────────────────────

const FETCH_INITIAL_DATA = 'DEBIT/FETCH_INITIAL_DATA';
const FETCH_INITIAL_DATA_SUCCESS = 'DEBIT/FETCH_INITIAL_DATA_SUCCESS';
const FETCH_INITIAL_DATA_FAILED = 'DEBIT/FETCH_INITIAL_DATA_FAILED';

const FETCH_ORDER_MAPPING = 'DEBIT/FETCH_ORDER_MAPPING';
const FETCH_ORDER_MAPPING_SUCCESS = 'DEBIT/FETCH_ORDER_MAPPING_SUCCESS';
const FETCH_ORDER_MAPPING_FAILED = 'DEBIT/FETCH_ORDER_MAPPING_FAILED';

const FETCH_LEGEND_MAPPING = 'DEBIT/FETCH_LEGEND_MAPPING';
const FETCH_LEGEND_MAPPING_SUCCESS = 'DEBIT/FETCH_LEGEND_MAPPING_SUCCESS';
const FETCH_LEGEND_MAPPING_FAILED = 'DEBIT/FETCH_LEGEND_MAPPING_FAILED';

const FETCH_CUSTOMERS = 'DEBIT/FETCH_CUSTOMERS';
const FETCH_CUSTOMERS_SUCCESS = 'DEBIT/FETCH_CUSTOMERS_SUCCESS';
const FETCH_CUSTOMERS_FAILED = 'DEBIT/FETCH_CUSTOMERS_FAILED';

const SUBMIT_ORDER_MAPPING = 'DEBIT/SUBMIT_ORDER_MAPPING';
const SUBMIT_ORDER_MAPPING_SUCCESS = 'DEBIT/SUBMIT_ORDER_MAPPING_SUCCESS';
const SUBMIT_ORDER_MAPPING_FAILED = 'DEBIT/SUBMIT_ORDER_MAPPING_FAILED';

const SUBMIT_LEGEND_MAPPING = 'DEBIT/SUBMIT_LEGEND_MAPPING';
const SUBMIT_LEGEND_MAPPING_SUCCESS = 'DEBIT/SUBMIT_LEGEND_MAPPING_SUCCESS';
const SUBMIT_LEGEND_MAPPING_FAILED = 'DEBIT/SUBMIT_LEGEND_MAPPING_FAILED';

const REJECT_LEGEND_ENTRY = 'DEBIT/REJECT_LEGEND_ENTRY';
const REJECT_LEGEND_ENTRY_SUCCESS = 'DEBIT/REJECT_LEGEND_ENTRY_SUCCESS';
const REJECT_LEGEND_ENTRY_FAILED = 'DEBIT/REJECT_LEGEND_ENTRY_FAILED';

const SUBMIT_REJECTED_ENTRY = 'DEBIT/SUBMIT_REJECTED_ENTRY';
const SUBMIT_REJECTED_ENTRY_SUCCESS = 'DEBIT/SUBMIT_REJECTED_ENTRY_SUCCESS';
const SUBMIT_REJECTED_ENTRY_FAILED = 'DEBIT/SUBMIT_REJECTED_ENTRY_FAILED';

const FETCH_WAREHOUSES = 'DEBIT/FETCH_WAREHOUSES';
const FETCH_WAREHOUSES_SUCCESS = 'DEBIT/FETCH_WAREHOUSES_SUCCESS';
const FETCH_WAREHOUSES_FAILED = 'DEBIT/FETCH_WAREHOUSES_FAILED';

const VALIDATE_ORDER_IDS = 'DEBIT/VALIDATE_ORDER_IDS';
const VALIDATE_ORDER_IDS_SUCCESS = 'DEBIT/VALIDATE_ORDER_IDS_SUCCESS';
const VALIDATE_ORDER_IDS_FAILED = 'DEBIT/VALIDATE_ORDER_IDS_FAILED';

const SEARCH_DEBIT_ORDERS = 'DEBIT/SEARCH_DEBIT_ORDERS';
const SEARCH_DEBIT_ORDERS_SUCCESS = 'DEBIT/SEARCH_DEBIT_ORDERS_SUCCESS';
const SEARCH_DEBIT_ORDERS_FAILED = 'DEBIT/SEARCH_DEBIT_ORDERS_FAILED';

const FETCH_DEBIT_ENTRY_DETAILS = 'DEBIT/FETCH_DEBIT_ENTRY_DETAILS';
const FETCH_DEBIT_ENTRY_DETAILS_SUCCESS =
  'DEBIT/FETCH_DEBIT_ENTRY_DETAILS_SUCCESS';
const FETCH_DEBIT_ENTRY_DETAILS_FAILED =
  'DEBIT/FETCH_DEBIT_ENTRY_DETAILS_FAILED';

export const FETCH_REJECTED_DEBIT_ENTRY_DETAILS =
  'FETCH_REJECTED_DEBIT_ENTRY_DETAILS';
export const FETCH_REJECTED_DEBIT_ENTRY_DETAILS_SUCCESS =
  'FETCH_REJECTED_DEBIT_ENTRY_DETAILS_SUCCESS';
export const FETCH_REJECTED_DEBIT_ENTRY_DETAILS_FAILED =
  'FETCH_REJECTED_DEBIT_ENTRY_DETAILS_FAILED';

const DOWNLOAD_DEBIT_TAGGING = 'DEBIT/DOWNLOAD_DEBIT_TAGGING';
const DOWNLOAD_DEBIT_TAGGING_SUCCESS = 'DEBIT/DOWNLOAD_DEBIT_TAGGING_SUCCESS';
const DOWNLOAD_DEBIT_TAGGING_FAILED = 'DEBIT/DOWNLOAD_DEBIT_TAGGING_FAILED';

const SUBMIT_LEGEND_TAGGING = 'DEBIT/SUBMIT_LEGEND_TAGGING';
const SUBMIT_LEGEND_TAGGING_SUCCESS = 'DEBIT/SUBMIT_LEGEND_TAGGING_SUCCESS';
const SUBMIT_LEGEND_TAGGING_FAILED = 'DEBIT/SUBMIT_LEGEND_TAGGING_FAILED';

const ADD_DEBIT_ENTRY_COMMENT = 'DEBIT/ADD_DEBIT_ENTRY_COMMENT';
const ADD_DEBIT_ENTRY_COMMENT_SUCCESS = 'DEBIT/ADD_DEBIT_ENTRY_COMMENT_SUCCESS';
const ADD_DEBIT_ENTRY_COMMENT_FAILED = 'DEBIT/ADD_DEBIT_ENTRY_COMMENT_FAILED';

const UPLOAD_PAYMENT_ADVICE = 'DEBIT/UPLOAD_PAYMENT_ADVICE';
const UPLOAD_PAYMENT_ADVICE_SUCCESS = 'DEBIT/UPLOAD_PAYMENT_ADVICE_SUCCESS';
const UPLOAD_PAYMENT_ADVICE_FAILED = 'DEBIT/UPLOAD_PAYMENT_ADVICE_FAILED';

const REMOVE_PAYMENT_ADVICE = 'DEBIT/REMOVE_PAYMENT_ADVICE';
const REMOVE_PAYMENT_ADVICE_SUCCESS = 'DEBIT/REMOVE_PAYMENT_ADVICE_SUCCESS';
const REMOVE_PAYMENT_ADVICE_FAILED = 'DEBIT/REMOVE_PAYMENT_ADVICE_FAILED';

const DELETE_DEBIT_ENTRY = 'DEBIT/DELETE_DEBIT_ENTRY';
const DELETE_DEBIT_ENTRY_SUCCESS = 'DEBIT/DELETE_DEBIT_ENTRY_SUCCESS';
const DELETE_DEBIT_ENTRY_FAILED = 'DEBIT/DELETE_DEBIT_ENTRY_FAILED';

const DOWNLOAD_ORDER_MAPPING_TEMPLATE = 'DEBIT/DOWNLOAD_ORDER_MAPPING_TEMPLATE';
const DOWNLOAD_ORDER_MAPPING_TEMPLATE_SUCCESS =
  'DEBIT/DOWNLOAD_ORDER_MAPPING_TEMPLATE_SUCCESS';
const DOWNLOAD_ORDER_MAPPING_TEMPLATE_FAILED =
  'DEBIT/DOWNLOAD_ORDER_MAPPING_TEMPLATE_FAILED';

const UPLOAD_ORDER_MAPPING_EXCEL = 'DEBIT/UPLOAD_ORDER_MAPPING_EXCEL';
const UPLOAD_ORDER_MAPPING_EXCEL_SUCCESS =
  'DEBIT/UPLOAD_ORDER_MAPPING_EXCEL_SUCCESS';
const UPLOAD_ORDER_MAPPING_EXCEL_FAILED =
  'DEBIT/UPLOAD_ORDER_MAPPING_EXCEL_FAILED';

const SET_ORDER_MAPPING_FILTERS = 'DEBIT/SET_ORDER_MAPPING_FILTERS';
const SET_LEGEND_MAPPING_FILTERS = 'DEBIT/SET_LEGEND_MAPPING_FILTERS';
const SET_ORDER_MAPPING_SUBTAB = 'DEBIT/SET_ORDER_MAPPING_SUBTAB';
const SET_LEGEND_MAPPING_SUBTAB = 'DEBIT/SET_LEGEND_MAPPING_SUBTAB';

// ─── Static Data ──────────────────────────────────────────────────────────────

// const BILLING_ENTITIES = ['Transin', 'Zast'];

const ORDER_MAPPING_SUBTABS = {
  ALL: 'all_pending',
  UNMAPPED: 'unmapped',
  PARTIALLY: 'partially',
  REJECTED: 'rejected',
  FULLY_MAPPED: 'fully_mapped',
};

// const DEBIT_STATUS = {
//   UNMAPPED: 'Unmapped',
//   PARTIALLY: 'Partially',
//   FULLY_MAPPED: 'Fully Mapped',
//   REJECTED: 'Rejected',
// };

// ─── Initial State ────────────────────────────────────────────────────────────

const INITIAL_STATE = {
  // Order Mapping
  fetchingOrderMapping: false,
  orderMappingData: [],
  orderMappingTotal: 0,
  orderMappingCounts: {},
  orderMappingPage: 1,
  orderMappingPageSize: 20,
  orderMappingSubTab: ORDER_MAPPING_SUBTABS.ALL,
  orderMappingFilters: {},
  downloadingDebitTagging: false,

  // Legend Mapping
  fetchingLegendMapping: false,
  legendMappingData: [],
  legendMappingTotal: 0,
  legendMappingCounts: {},
  legendMappingPage: 1,
  legendMappingPageSize: 20,
  legendMappingFilters: {},
  legendMappingSubTab: 'open',

  // Initial data from /delta-debit-tagging/initial/
  fetchingInitialData: false,
  debitTaggingInitialData: {},

  // Warehouses for legend mapping From/To WH filters
  fetchingWarehouses: false,
  warehouses: [],

  // Order search in modal
  searchingDebitOrders: false,
  debitOrderValidResults: [],
  debitOrderInvalidResults: [],

  // Debit entry details (modal table pre-fill)
  fetchingDebitEntryDetails: false,

  // Order ID validation in modal
  validatingOrderIds: false,

  // Submission loaders
  submittingOrderMapping: false,
  submittingLegendMapping: false,
  submittingLegendTagging: false,
  rejectingLegendEntry: false,
  submittingRejectedEntry: false,
  addingDebitComment: false,
  uploadingPaymentAdvice: false,
  removingPaymentAdvice: false,
  deletingDebitEntry: false,
  downloadingOrderMappingTemplate: false,
  uploadingOrderMappingExcel: false,

  hasError: false,
  error: '',
};

// ─── Reducer ──────────────────────────────────────────────────────────────────

export default function debitTaggingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Initial Data
    case FETCH_INITIAL_DATA:
      return {...state, fetchingInitialData: true};
    case FETCH_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        fetchingInitialData: false,
        debitTaggingInitialData: action.payload,
      };
    case FETCH_INITIAL_DATA_FAILED:
      return {...state, fetchingInitialData: false};

    // Order Mapping
    case FETCH_ORDER_MAPPING:
      return {...state, fetchingOrderMapping: true, hasError: false};
    case FETCH_ORDER_MAPPING_SUCCESS:
      return {
        ...state,
        fetchingOrderMapping: false,
        orderMappingData: action.payload.records || [],
        orderMappingTotal: action.payload.total || 0,
        orderMappingCounts: action.payload.counts || {},
      };
    case FETCH_ORDER_MAPPING_FAILED:
      return {
        ...state,
        fetchingOrderMapping: false,
        hasError: true,
        error: action.payload,
      };

    // Legend Mapping
    case FETCH_LEGEND_MAPPING:
      return {...state, fetchingLegendMapping: true, hasError: false};
    case FETCH_LEGEND_MAPPING_SUCCESS:
      return {
        ...state,
        fetchingLegendMapping: false,
        legendMappingData: (action.payload.records || []).map((row) => ({
          ...row,
          legend_sub_category_id: row.legend?.legend_sub_category_id,
          legend_sub_category: row.legend?.legend_sub_category,
          legend_category_name: row.legend?.legend_category,
        })),
        legendMappingTotal: action.payload.total || 0,
        legendMappingCounts: action.payload.counts || state.legendMappingCounts,
      };
    case FETCH_LEGEND_MAPPING_FAILED:
      return {
        ...state,
        fetchingLegendMapping: false,
        hasError: true,
        error: action.payload,
      };

    // Customers
    case FETCH_CUSTOMERS:
      return {...state, fetchingCustomers: true};
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        fetchingCustomers: false,
        debitCustomers: action.payload,
      };
    case FETCH_CUSTOMERS_FAILED:
      return {...state, fetchingCustomers: false};

    // Warehouses
    case FETCH_WAREHOUSES:
      return {...state, fetchingWarehouses: true, warehouses: []};
    case FETCH_WAREHOUSES_SUCCESS:
      return {...state, fetchingWarehouses: false, warehouses: action.payload};
    case FETCH_WAREHOUSES_FAILED:
      return {...state, fetchingWarehouses: false};

    // Search Debit Orders (modal)
    case SEARCH_DEBIT_ORDERS:
      return {
        ...state,
        searchingDebitOrders: true,
        debitOrderValidResults: [],
        debitOrderInvalidResults: [],
      };
    case SEARCH_DEBIT_ORDERS_SUCCESS:
      return {
        ...state,
        searchingDebitOrders: false,
        debitOrderValidResults: action.payload?.valid_orders || [],
        debitOrderInvalidResults: action.payload?.invalid_orders || [],
      };
    case SEARCH_DEBIT_ORDERS_FAILED:
      return {
        ...state,
        searchingDebitOrders: false,
        debitOrderValidResults: [],
        debitOrderInvalidResults: [],
      };

    // Debit Entry Details
    case FETCH_DEBIT_ENTRY_DETAILS:
      return {...state, fetchingDebitEntryDetails: true};
    case FETCH_DEBIT_ENTRY_DETAILS_SUCCESS:
    case FETCH_DEBIT_ENTRY_DETAILS_FAILED:
      return {...state, fetchingDebitEntryDetails: false};

    case FETCH_REJECTED_DEBIT_ENTRY_DETAILS:
      return {...state, fetchingDebitEntryDetails: true};
    case FETCH_REJECTED_DEBIT_ENTRY_DETAILS_SUCCESS:
    case FETCH_REJECTED_DEBIT_ENTRY_DETAILS_FAILED:
      return {...state, fetchingDebitEntryDetails: false};

    // Download
    case DOWNLOAD_DEBIT_TAGGING:
      return {...state, downloadingDebitTagging: true};
    case DOWNLOAD_DEBIT_TAGGING_SUCCESS:
    case DOWNLOAD_DEBIT_TAGGING_FAILED:
      return {...state, downloadingDebitTagging: false};

    // Order ID validation
    case VALIDATE_ORDER_IDS:
      return {...state, validatingOrderIds: true};
    case VALIDATE_ORDER_IDS_SUCCESS:
    case VALIDATE_ORDER_IDS_FAILED:
      return {...state, validatingOrderIds: false};

    // Submit Order Mapping
    case SUBMIT_ORDER_MAPPING:
      return {...state, submittingOrderMapping: true};
    case SUBMIT_ORDER_MAPPING_SUCCESS: {
      const {id, records, counts} = action.payload;
      return {
        ...state,
        submittingOrderMapping: false,
        //sp-209 maybe required
        // orderMappingData: records
        //   ? state.orderMappingData.map((row) =>
        //       String(row.id) === String(id) ? {...row, ...records} : row,
        //     )
        //   : state.orderMappingData,
        // ...(counts ? {orderMappingCounts: counts} : {}),
      };
    }
    case SUBMIT_ORDER_MAPPING_FAILED:
      return {...state, submittingOrderMapping: false};

    // Submit Legend Mapping
    case SUBMIT_LEGEND_MAPPING:
      return {...state, submittingLegendMapping: true};
    case SUBMIT_LEGEND_MAPPING_SUCCESS:
    case SUBMIT_LEGEND_MAPPING_FAILED:
      return {...state, submittingLegendMapping: false};

    // Submit Legend Tagging (Save button in Legend Category column)
    case SUBMIT_LEGEND_TAGGING:
      return {...state, submittingLegendTagging: true};
    case SUBMIT_LEGEND_TAGGING_SUCCESS: {
      const {records: updatedRecord, counts} = action.payload;
      const isSameId = (a, b) => String(a) === String(b);
      const updatedData = state.legendMappingData.filter(
        (row) => !isSameId(row.id, updatedRecord.id),
      );
      return {
        ...state,
        submittingLegendTagging: false,
        legendMappingData: updatedData,
        legendMappingTotal: Math.max(0, state.legendMappingTotal - 1),
        legendMappingCounts: counts || state.legendMappingCounts,
      };
    }
    case SUBMIT_LEGEND_TAGGING_FAILED:
      return {...state, submittingLegendTagging: false};

    // Reject Legend Entry
    case REJECT_LEGEND_ENTRY:
      return {...state, rejectingLegendEntry: true};
    case REJECT_LEGEND_ENTRY_SUCCESS:
      return {
        ...state,
        rejectingLegendEntry: false,
        legendMappingData: state.legendMappingData.filter(
          (row) => String(row.id) !== String(action.payload.id),
        ),
        legendMappingTotal: Math.max(0, state.legendMappingTotal - 1),
        legendMappingCounts: action.payload.counts || state.legendMappingCounts,
      };
    case REJECT_LEGEND_ENTRY_FAILED:
      return {...state, rejectingLegendEntry: false};

    // Submit Rejected Entry
    case SUBMIT_REJECTED_ENTRY:
      return {...state, submittingRejectedEntry: true};
    case SUBMIT_REJECTED_ENTRY_SUCCESS:
    case SUBMIT_REJECTED_ENTRY_FAILED:
      return {...state, submittingRejectedEntry: false};

    // Add Debit Entry Comment
    case ADD_DEBIT_ENTRY_COMMENT:
      return {...state, addingDebitComment: true};
    case ADD_DEBIT_ENTRY_COMMENT_SUCCESS:
    case ADD_DEBIT_ENTRY_COMMENT_FAILED:
      return {...state, addingDebitComment: false};

    // Upload Payment Advice
    case UPLOAD_PAYMENT_ADVICE:
      return {...state, uploadingPaymentAdvice: true};
    case UPLOAD_PAYMENT_ADVICE_SUCCESS:
      return {
        ...state,
        uploadingPaymentAdvice: false,
        orderMappingData: state.orderMappingData.map((row) =>
          String(row.id) === String(action.payload.id)
            ? {...row, payment_advice: action.payload.records}
            : row,
        ),
      };
    case UPLOAD_PAYMENT_ADVICE_FAILED:
      return {...state, uploadingPaymentAdvice: false};

    // Remove Payment Advice
    case REMOVE_PAYMENT_ADVICE:
      return {...state, removingPaymentAdvice: true};
    case REMOVE_PAYMENT_ADVICE_SUCCESS:
      return {
        ...state,
        removingPaymentAdvice: false,
        orderMappingData: state.orderMappingData.map((row) =>
          String(row.id) === String(action.payload.id)
            ? {...row, payment_advice: []}
            : row,
        ),
      };
    case REMOVE_PAYMENT_ADVICE_FAILED:
      return {...state, removingPaymentAdvice: false};

    // Delete Debit Entry
    case DELETE_DEBIT_ENTRY:
      return {...state, deletingDebitEntry: true};
    case DELETE_DEBIT_ENTRY_SUCCESS: {
      const deletedExisted = state.orderMappingData.some(
        (row) => String(row.id) === String(action.payload.id),
      );
      return {
        ...state,
        deletingDebitEntry: false,
        orderMappingData: state.orderMappingData.filter(
          (row) => String(row.id) !== String(action.payload.id),
        ),
        orderMappingTotal: deletedExisted
          ? Math.max(0, state.orderMappingTotal - 1)
          : state.orderMappingTotal,
      };
    }
    case DELETE_DEBIT_ENTRY_FAILED:
      return {...state, deletingDebitEntry: false};

    // Download Order Mapping Template
    case DOWNLOAD_ORDER_MAPPING_TEMPLATE:
      return {...state, downloadingOrderMappingTemplate: true};
    case DOWNLOAD_ORDER_MAPPING_TEMPLATE_SUCCESS:
    case DOWNLOAD_ORDER_MAPPING_TEMPLATE_FAILED:
      return {...state, downloadingOrderMappingTemplate: false};

    // Upload Order Mapping Excel
    case UPLOAD_ORDER_MAPPING_EXCEL:
      return {...state, uploadingOrderMappingExcel: true};
    case UPLOAD_ORDER_MAPPING_EXCEL_SUCCESS: {
      const uploadedRecords = action.payload?.records || [];
      if (!uploadedRecords.length) {
        return {...state, uploadingOrderMappingExcel: false};
      }
      const existingIds = new Set(
        state.orderMappingData.map((row) => String(row.id)),
      );
      const updatedData = state.orderMappingData.map((row) => {
        const match = uploadedRecords.find(
          (record) => String(record.id) === String(row.id),
        );
        return match ? {...row, ...match} : row;
      });
      const newRecords = uploadedRecords.filter(
        (record) => !existingIds.has(String(record.id)),
      );
      return {
        ...state,
        uploadingOrderMappingExcel: false,
        orderMappingData: [...newRecords, ...updatedData],
        orderMappingTotal: state.orderMappingTotal + newRecords.length,
      };
    }
    case UPLOAD_ORDER_MAPPING_EXCEL_FAILED:
      return {...state, uploadingOrderMappingExcel: false};

    // Filters & Subtab
    case SET_ORDER_MAPPING_FILTERS:
      return {
        ...state,
        orderMappingFilters: action.payload,
        orderMappingPage: 1,
      };
    case SET_LEGEND_MAPPING_FILTERS:
      return {
        ...state,
        legendMappingFilters: action.payload,
        legendMappingPage: 1,
      };
    case SET_ORDER_MAPPING_SUBTAB:
      return {
        ...state,
        orderMappingSubTab: action.payload,
        orderMappingPage: 1,
      };
    case SET_LEGEND_MAPPING_SUBTAB:
      return {
        ...state,
        legendMappingSubTab: action.payload,
        legendMappingPage: 1,
      };

    default:
      return state;
  }
}

// ─── Action Creators ──────────────────────────────────────────────────────────

export const fetchOrderMappingData = (params = {}) => {
  return async (dispatch) => {
    dispatch({type: FETCH_ORDER_MAPPING});
    const {page = 1, sub_tab, ...bodyFilters} = params;
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.getDebitSearchURL(page),
      data: {
        action: 'order_mapping',
        sub_tab: sub_tab || 'all_pending',
        ...bodyFilters,
      },
    });
    if (response.status) {
      dispatch({type: FETCH_ORDER_MAPPING_SUCCESS, payload: response.data});
    } else {
      dispatch({type: FETCH_ORDER_MAPPING_FAILED, payload: response.message});
    }
    return response;
  };
};

export const fetchLegendMappingData = (params = {}) => {
  return async (dispatch) => {
    dispatch({type: FETCH_LEGEND_MAPPING});
    const {page = 1, ...bodyFilters} = params;
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.getDebitSearchURL(page),
      data: {
        action: 'legend_mapping',
        ...bodyFilters,
      },
    });
    if (response.status) {
      dispatch({type: FETCH_LEGEND_MAPPING_SUCCESS, payload: response.data});
    } else {
      dispatch({type: FETCH_LEGEND_MAPPING_FAILED, payload: response.message});
    }
    return response;
  };
};

export const fetchInitialData = () => {
  return async (dispatch) => {
    dispatch({type: FETCH_INITIAL_DATA});
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getDebitInitialDataURL(),
    });
    if (response.status) {
      dispatch({type: FETCH_INITIAL_DATA_SUCCESS, payload: response.data});
    } else {
      dispatch({type: FETCH_INITIAL_DATA_FAILED});
    }
    return response;
  };
};

export const fetchDebitCustomers = () => {
  return async (dispatch) => {
    dispatch({type: FETCH_CUSTOMERS});
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getDebitCustomersURL(),
    });
    if (response.status) {
      dispatch({type: FETCH_CUSTOMERS_SUCCESS, payload: response.data});
    } else {
      dispatch({type: FETCH_CUSTOMERS_FAILED});
    }
    return response;
  };
};

export const searchDebitOrders = (customerId, search) => {
  return async (dispatch) => {
    dispatch({type: SEARCH_DEBIT_ORDERS});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.searchDeltaDebitOrdersURL(),
      data: {customer_id: customerId, search},
    });
    if (response.status) {
      dispatch({type: SEARCH_DEBIT_ORDERS_SUCCESS, payload: response.data});
    } else {
      dispatch({type: SEARCH_DEBIT_ORDERS_FAILED});
    }
    return response;
  };
};

export const validateOrderIds = (customerId, orderIds) => {
  return async (dispatch) => {
    dispatch({type: VALIDATE_ORDER_IDS});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.validateDebitOrderIdsURL(),
      data: {customer_id: customerId, order_ids: orderIds},
    });
    if (response.status) {
      dispatch({type: VALIDATE_ORDER_IDS_SUCCESS});
    } else {
      dispatch({type: VALIDATE_ORDER_IDS_FAILED});
    }
    return response;
  };
};

export const fetchWarehousesByCustomer = (customerId) => {
  return async (dispatch) => {
    dispatch({type: FETCH_WAREHOUSES});
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getDebitWarehousesByCustomerURL(customerId),
    });
    if (response.status) {
      dispatch({type: FETCH_WAREHOUSES_SUCCESS, payload: response.data});
    } else {
      dispatch({type: FETCH_WAREHOUSES_FAILED});
    }
    return response;
  };
};

export const fetchDebitEntryDetails = (id) => {
  return async (dispatch) => {
    dispatch({type: FETCH_DEBIT_ENTRY_DETAILS});
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getDebitEntryDetailsURL(id),
    });
    if (response.status) {
      dispatch({type: FETCH_DEBIT_ENTRY_DETAILS_SUCCESS});
    } else {
      dispatch({type: FETCH_DEBIT_ENTRY_DETAILS_FAILED});
    }
    return response;
  };
};

export const fetchRejectedDebitDetails = (id) => {
  return async (dispatch) => {
    dispatch({type: FETCH_REJECTED_DEBIT_ENTRY_DETAILS});
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getRejectedDebitEntryDetailsURL(id),
    });

    if (response.status) {
      dispatch({type: FETCH_REJECTED_DEBIT_ENTRY_DETAILS_SUCCESS});
    } else {
      dispatch({type: FETCH_REJECTED_DEBIT_ENTRY_DETAILS_FAILED});
    }
    return response;
  };
};

export const submitOrderMapping = (debitEntryId, rows) => {
  return async (dispatch) => {
    dispatch({type: SUBMIT_ORDER_MAPPING});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.submitDebitOrdersMappingURL(),
      data: {debit_entry_id: debitEntryId, rows},
    });
    if (response.status) {
      dispatch({
        type: SUBMIT_ORDER_MAPPING_SUCCESS,
        payload: {id: debitEntryId, ...response.data},
      });
    } else {
      dispatch({type: SUBMIT_ORDER_MAPPING_FAILED});
    }
    return response;
  };
};

export const submitLegendMapping = (entryId, legendSubCategory) => {
  return async (dispatch) => {
    dispatch({type: SUBMIT_LEGEND_MAPPING});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.submitDebitLegendMappingURL(),
      data: {entry_id: entryId, legend_sub_category: legendSubCategory},
    });
    if (response.status) {
      dispatch({type: SUBMIT_LEGEND_MAPPING_SUCCESS});
    } else {
      dispatch({type: SUBMIT_LEGEND_MAPPING_FAILED});
    }
    return response;
  };
};

export const rejectLegendEntry = (mappingId, rejectedReason) => {
  return async (dispatch) => {
    dispatch({type: REJECT_LEGEND_ENTRY});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.deltaDebitLegendRejectURL(),
      data: {id: mappingId, rejected_reason: rejectedReason},
    });
    if (response.status) {
      dispatch({
        type: REJECT_LEGEND_ENTRY_SUCCESS,
        payload: {id: mappingId, counts: response.data?.counts},
      });
    } else {
      dispatch({type: REJECT_LEGEND_ENTRY_FAILED});
    }
    return response;
  };
};

export const submitRejectedEntry = (entryId, updatedData) => {
  return async (dispatch) => {
    dispatch({type: SUBMIT_REJECTED_ENTRY});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.submitDebitRejectedEntryURL(),
      data: {entry_id: entryId, ...updatedData},
    });
    if (response.status) {
      dispatch({type: SUBMIT_REJECTED_ENTRY_SUCCESS});
    } else {
      dispatch({type: SUBMIT_REJECTED_ENTRY_FAILED});
    }
    return response;
  };
};

export const submitLegendTagging = (mappingId, legendSubCategoryId, subTab) => {
  return async (dispatch) => {
    dispatch({type: SUBMIT_LEGEND_TAGGING});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.deltaDebitLegendTaggingURL(),
      data: {
        id: mappingId,
        legend_sub_category_id: legendSubCategoryId,
        sub_tab: subTab,
      },
    });
    if (response.status) {
      dispatch({
        type: SUBMIT_LEGEND_TAGGING_SUCCESS,
        payload: {
          records: response.data.records,
          counts: response.data.counts,
          responseSub_tab: response.data.sub_tab,
          currentSubTab: subTab,
        },
      });
    } else {
      dispatch({type: SUBMIT_LEGEND_TAGGING_FAILED});
    }
    return response;
  };
};

export const downloadDebitTagging = (action) => {
  return async (dispatch) => {
    dispatch({type: DOWNLOAD_DEBIT_TAGGING});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.downloadDebitTaggingURL(),
      data: {action},
    });
    if (response.status) {
      dispatch({type: DOWNLOAD_DEBIT_TAGGING_SUCCESS});
    } else {
      dispatch({type: DOWNLOAD_DEBIT_TAGGING_FAILED});
    }
    return response;
  };
};

export const addDebitEntryComment = (rowId, comment) => {
  return async (dispatch) => {
    dispatch({type: ADD_DEBIT_ENTRY_COMMENT});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.addDebitEntryCommentURL(),
      data: {id: rowId, comment},
    });
    if (response.status) {
      dispatch({type: ADD_DEBIT_ENTRY_COMMENT_SUCCESS});
    } else {
      dispatch({type: ADD_DEBIT_ENTRY_COMMENT_FAILED});
    }
    return response;
  };
};

export const uploadPaymentAdvice = (debitEntryId, file) => {
  return async (dispatch) => {
    dispatch({type: UPLOAD_PAYMENT_ADVICE});
    const formData = new FormData();
    formData.append('doc_file', file);
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.uploadPaymentAdviceURL(debitEntryId),
      data: formData,
    });
    const records = Array.isArray(response?.records)
      ? response.records
      : Array.isArray(response?.data?.records)
      ? response.data.records
      : null;
    if (
      records !== null &&
      (response?.status === undefined || response?.status)
    ) {
      dispatch({
        type: UPLOAD_PAYMENT_ADVICE_SUCCESS,
        payload: {id: debitEntryId, records},
      });
    } else {
      dispatch({type: UPLOAD_PAYMENT_ADVICE_FAILED});
    }
    return response;
  };
};

export const removePaymentAdvice = (debitEntryId, key) => {
  return async (dispatch) => {
    dispatch({type: REMOVE_PAYMENT_ADVICE});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.removePaymentAdviceURL(debitEntryId),
      data: {key},
    });
    if (response.status) {
      dispatch({
        type: REMOVE_PAYMENT_ADVICE_SUCCESS,
        payload: {id: debitEntryId},
      });
    } else {
      dispatch({type: REMOVE_PAYMENT_ADVICE_FAILED});
    }
    return response;
  };
};

export const deleteDebitEntry = (debitEntryId) => {
  return async (dispatch) => {
    dispatch({type: DELETE_DEBIT_ENTRY});
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.deleteDebitEntryURL(debitEntryId),
    });
    if (response.status) {
      dispatch({
        type: DELETE_DEBIT_ENTRY_SUCCESS,
        payload: {id: debitEntryId},
      });
    } else {
      dispatch({type: DELETE_DEBIT_ENTRY_FAILED});
    }
    return response;
  };
};

export const downloadOrderMappingTemplate = () => {
  return async (dispatch) => {
    dispatch({type: DOWNLOAD_ORDER_MAPPING_TEMPLATE});
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.downloadOrderMappingTemplateURL(),
    });
    if (response && response.status !== false) {
      dispatch({type: DOWNLOAD_ORDER_MAPPING_TEMPLATE_SUCCESS});
    } else {
      dispatch({type: DOWNLOAD_ORDER_MAPPING_TEMPLATE_FAILED});
    }
    return response;
  };
};

export const uploadOrderMappingExcel = (file) => {
  return async (dispatch) => {
    dispatch({type: UPLOAD_ORDER_MAPPING_EXCEL});
    const formData = new FormData();
    formData.append('file', file);
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.uploadOrderMappingExcelURL(),
      data: formData,
    });
    if (response && response.status !== false) {
      dispatch({
        type: UPLOAD_ORDER_MAPPING_EXCEL_SUCCESS,
        payload: response.data || {},
      });
    } else {
      dispatch({type: UPLOAD_ORDER_MAPPING_EXCEL_FAILED});
    }
    return response;
  };
};

export const setOrderMappingFilters = (filters) => ({
  type: SET_ORDER_MAPPING_FILTERS,
  payload: filters,
});

export const setLegendMappingFilters = (filters) => ({
  type: SET_LEGEND_MAPPING_FILTERS,
  payload: filters,
});

export const setOrderMappingSubTab = (tab) => ({
  type: SET_ORDER_MAPPING_SUBTAB,
  payload: tab,
});

export const setLegendMappingSubTab = (tab) => ({
  type: SET_LEGEND_MAPPING_SUBTAB,
  payload: tab,
});
